



































import { Component, Prop, Vue } from "vue-property-decorator";
@Component({
  components: {
    "tickets-inbox-item-template": () =>
      import("@/components/app/global/tickets/ticketsInboxItemTemplate.vue")
  }
})
export default class TicketsInboxSkeleton extends Vue {
  @Prop({ default: 5 })
  public items!: number;
  @Prop({ default: true })
  public isAnimated!: boolean;
}
